const donationVariants = {
  5: 51364783325458,
  10: 51364783358226,
  20: 51364783390994,
  50: 51364783423762,
  100: 51364783456530,
  150: 51364783489298,
  200: 51364783522066,
  250: 51364783554834,
  500: 51364783587602,
  1000: 51364783620370
};

function addDonation(amount) {
  if (!amount) return;

  const variantId = donationVariants[amount];
  if (!variantId) {
    alert("Donation amount not available.");
    return;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        quantity: 1,
        id: variantId,
        properties: { "Donation": `$${amount}` }
      }]
    })
  })
  .then(res => res.json())
  .then(() => {
    window.location.reload(); // Refresh cart to show donation
  })
  .catch(err => {
    alert("Failed to add donation. Please try again.");
    console.error(err);
  });
}